import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_billing_code_editor___ds_billing_code_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { billing_code_id: number }): 
  Promise<{ result: { Id?: number, Description?: string, Name?: string, NumericSplitTypeId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billing_code_id)) {
      $missingRequiredInParams.push('\'billing_code_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      billing_code_id: number    }) {
        if(isNil($inParams.billing_code_id)) {
          return true; 
        }
      return false;
    }
}
